import { useCallback, useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { StatusPill } from "../components/common";
import { QrisCheckout } from "./QrisCheckout";
import { EACard } from "./EACard";
import { api, date, idr } from "../lib/api";

export default function EARental() {
  const [items, setItems] = useState([]);
  const [rentals, setRentals] = useState([]);
  const [payments, setPayments] = useState([]);
  const [selected, setSelected] = useState(null);
  const [sent, setSent] = useState(false);
  const load = useCallback(() => {
    api.get("/ea/rentals").then((r) => setRentals(r.data));
    api.get("/payments/mine").then((r) => setPayments(r.data.filter((p) => p.kind === "ea_rental")));
  }, []);
  useEffect(() => { api.get("/ea/catalog").then((r) => setItems(r.data)); load(); }, [load]);
  const activeFor = (id) => rentals.find((r) => r.ea_id === id && new Date(r.end) > new Date());

  return (
    <>
      <div className="page-intro">
        <div><p className="eyebrow">AUTOMATED STRATEGIES</p><h2>Sewa EA</h2><p className="muted">Paket bulanan 30 hari. Aktif otomatis setelah pembayaran diverifikasi admin.</p></div>
      </div>
      {sent && <div className="notice" data-testid="payment-success-message"><ShieldCheck size={19} /> Bukti pembayaran berhasil dikirim dan menunggu verifikasi admin.</div>}
      {rentals.filter((r) => new Date(r.end) > new Date()).length > 0 && (
        <div className="active-rentals" data-testid="active-rentals">
          <p className="eyebrow">EA AKTIF ANDA</p>
          {rentals.filter((r) => new Date(r.end) > new Date()).map((r) => (
            <span key={r.id} className="pill ok" data-testid={`active-rental-${r.ea_id}`}>{r.ea_name} · s/d {date(r.end)}</span>
          ))}
        </div>
      )}
      <div className="ea-grid">
        {items.map((e) => <EACard key={`${e.id}-${activeFor(e.id)?.id || ""}`} ea={e} active={activeFor(e.id)} onRent={(ea, trading) => { setSelected({ ...ea, trading }); setSent(false); }} />)}
      </div>
      <section className="panel table-panel mt">
        <div className="panel-head"><h3>Riwayat pembayaran sewa</h3></div>
        <div className="table-row table-head"><span>TANGGAL</span><span>EA</span><span>NOMINAL</span><span>STATUS</span></div>
        {payments.length === 0 && <p className="muted pad-y">Belum ada pembayaran.</p>}
        {payments.map((p) => (
          <div className="table-row" key={p.id} data-testid={`my-payment-${p.id}`}>
            <span>{date(p.created_at)}</span><span>{p.title}</span><span>{idr(p.amount)}</span>
            <span className="row-end"><StatusPill status={p.status} />{p.review_note && <small className="muted">{p.review_note}</small>}</span>
          </div>
        ))}
      </section>
      {selected && (
        <QrisCheckout title={selected.name} subtitle="Scan QRIS di bawah, bayar sesuai nominal, lalu unggah bukti transfer." amount={selected.monthly}
          fields={{ kind: "ea_rental", ea_id: selected.id }} proofFields={selected.trading} onClose={() => setSelected(null)} onDone={() => { setSelected(null); setSent(true); load(); }} />
      )}
    </>
  );
}
